import { useState, useEffect, useCallback } from 'react';
import { getDigitalCard, DigitalCardResponse } from '../services/digitalCardService';
import { Logger } from '../utils/logger';

export const useDigitalCard = () => {
  const [digitalCard, setDigitalCard] = useState<DigitalCardResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchDigitalCard = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getDigitalCard();
      Logger.log('[useDigitalCard] Fetched digital card:', response.data);

      if (response.data && response.data.data) {
        setDigitalCard(response.data.data);
      } else {
        // No digital card exists yet
        setDigitalCard(null);
      }
    } catch (err: any) {
      // 404 means no digital card exists yet, which is fine
      if (err?.response?.status === 404) {
        Logger.log('[useDigitalCard] No digital card found (404)');
        setDigitalCard(null);
      } else {
        const errorMessage = err?.response?.data?.message || err?.message || 'Failed to fetch digital card';
        Logger.error('[useDigitalCard] Error:', errorMessage);
        setError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDigitalCard();
  }, [fetchDigitalCard]);

  return {
    digitalCard,
    loading,
    error,
    refetch: fetchDigitalCard
  };
};
